import(/* webpackMode: "eager" */ "/schnitt/app/global-error.tsx")